import styles from "./ErrorPage.module.scss";
import errorImage from "../../assets/images/error-image.png";
import {useTranslation} from "react-i18next";

const ErrorPage = () => {

    const {t} = useTranslation();

    return (
        <div className={styles.page}>
            <div className={styles.wrapper}>
                <img className={styles.image} src={errorImage} alt={"Error"}/>
                <h2 className={styles.title}>{t("WeHaveEncounteredAProblem")}</h2>
                <p className={styles.text}>{t("TheFunctionalityOfThisPage")}</p>
            </div>
        </div>
    )
}

export default ErrorPage;